import { Option } from "@/components/Forms/Dropdown";

type AudienceSegmentsMap = {
  [clientId: string]: Array<Option<string>>;
};

const audienceSegments: AudienceSegmentsMap = {
  "2215238550": [
    {
      label: "No audience",
      value: "",
    },
    {
      label: "Gotcha! Audience",
      value: "Gotcha! Viewers 90d.",
    },
    {
      label: "Niche Audience",
      value: "Gotcha! Zoom Combo 90d.",
    },
    {
      label: "Niche & Similar",
      value: "Niche & Similar 90d.",
    },
  ],
  "6314155145": [
    {
      label: "No audience",
      value: "",
    },
    {
      label: "Kaboom Audience",
      value: "Kaboom Team Audience",
    },
    {
      label: "Niche Audience",
      value: "BPS COMBO 90d.",
    },
    {
      label: "Niche & Similar",
      value: "BPS COMBO + SIMILAR 90d.",
    },
  ],
  "1260289095": [
    {
      label: "No audience",
      value: "",
    },
    {
      label: "Mad Lads Audience",
      value: "Mad Lads Audience 90d",
    },
    // {
    //   label: "Niche Audience",
    //   value: "",
    // },
    {
      label: "Niche & Similar",
      value: "Mad Lads Combo",
    },
  ],
  "3811412666": [
    {
      label: "No audience",
      value: "",
    },
    {
      label: "Lily Audience",
      value: "Little Lily 90d.",
    },
    {
      label: "Niche Audience",
      value: "Little Lily COMBO 90d.",
    },
    // {
    //   label: "Niche & Similar",
    //   value: "",
    // },
  ],
  "4601030954": [
    {
      label: "No audience",
      value: "",
    },
    {
      label: "Snapchat Audience",
      value: "FCS 90d.",
    },
    {
      label: "Tottaly Handy Audience",
      value: "Totally Handy Combo 90d.",
    },
    {
      label: "Niche Audience",
      value: "TH/FCS 90d.",
    },
    {
      label: "Niche & Similar",
      value: "FCS COMBO 90d.",
    },
  ],
};

export const getAudienceSegments = (gaClient: string) => {
  return (
    audienceSegments[gaClient] ?? [
      {
        label: "No audience",
        value: "",
      },
    ]
  );
};
